import { ReportDownloadModal } from '@features/reports';
import { useCampaignParameters } from '../hooks/useCampaign';
import { useCurrentChannel } from '../../../hooks/useCurrentChannel';
import { useCurrentReport } from '../hooks/useReports';
import { DownloadButton } from '@features/campaigns/components/DownloadButton';

type DownloadProps = {
  campaignName: string;
};

export const Download = (props: DownloadProps) => {
  const { report, salesReport } = useCurrentReport();
  const { channel } = useCurrentChannel();
  const campaignParams = useCampaignParameters(report?.campaignId);

  if (!report) return null;

  return (
    <ReportDownloadModal
      campaignName={props.campaignName}
      campaignId={report.campaignId}
      getCampaignParams={campaignParams}
      reportType={report.reportType}
      reportId={report.id}
      salesReportId={salesReport?.id ?? null}
      channel={channel ?? undefined}
      enableSalesDownloads={!!salesReport?.salesMetrics}
      renderOpener={onClick => <DownloadButton onClick={onClick} />}
    />
  );
};
